// exp_PORTFOLIO-58018_file
import { ChangeEventHandler, FC, useState } from 'react';

import { formatCost } from 'utils/clickme';
import { PRESETS_CONFIG, VrPresets } from 'utils/vrCampaign';

import vrPackageResponsesPresetButtonClick, {
    Preset as PresetAnalytics,
} from '@hh.ru/analytics-js-events/build/clickme/employer/campaign_menu/vr_package/vr_package_responses_preset_button_click';
import { CheckableCard, Flex, Text, useBreakpoint, VSpacing } from '@hh.ru/magritte-ui';

import useTrls from 'hooks/translation/useTrls';

import {
    setVrCampaignBudget,
    setVrCampaignErrors,
    setVrCampaignPreset,
    setVrCampaignResponses,
} from 'store/models/vrCampaign';
import { useDispatch } from 'store/utils';

const TrlKeys = {
    title: 'VrCampaignBuilderPage.presets.title',
    budget: 'VrCampaignBuilderPage.presets.budget',
    label: 'VrCampaignBuilderPage.presets.label',
    custom: 'VrCampaignBuilderPage.presets.custom',
};

export const Presets: FC = () => {
    const [checkedPreset, setCheckedPreset] = useState(VrPresets.Medium);

    const trls = useTrls();
    const dispatch = useDispatch();
    const { isMobile } = useBreakpoint();

    const handleChangePreset: ChangeEventHandler<HTMLInputElement> = (event) => {
        const preset = event.target.value as VrPresets;
        setCheckedPreset(preset);

        const { budget, responses } =
            preset === VrPresets.Custom ? PRESETS_CONFIG[VrPresets.Small] : PRESETS_CONFIG[preset];

        dispatch([
            setVrCampaignBudget(budget),
            setVrCampaignResponses(responses),
            setVrCampaignPreset(preset),
            setVrCampaignErrors({ responses: false, budget: false }),
        ]);

        vrPackageResponsesPresetButtonClick({
            preset: preset as unknown as PresetAnalytics,
            responsesCount: responses,
            amount: budget,
        });
    };

    return (
        <>
            <Text>{trls(TrlKeys.title)}</Text>
            <VSpacing default={12} />
            <Flex direction={isMobile ? 'column' : 'row'} gap={12}>
                {Object.entries(PRESETS_CONFIG).map(([key, value]) => (
                    <Flex key={key} grow={1} basis={0}>
                        <CheckableCard
                            flexible
                            padding={16}
                            borderRadius={16}
                            type="radio"
                            name="presets"
                            value={key}
                            checked={checkedPreset === key}
                            onChange={handleChangePreset}
                            data-qa={`vr-campaign-preset-${key.toLowerCase()}`}
                        >
                            <Flex gap={8} direction="column">
                                <Text typography="subtitle-1-semibold">
                                    {value.responses ? trls(TrlKeys.label, [value.responses]) : trls(TrlKeys.custom)}
                                </Text>
                                {!!value.budget && (
                                    <Text style="secondary">{trls(TrlKeys.budget, [formatCost(value.budget)])}</Text>
                                )}
                            </Flex>
                        </CheckableCard>
                    </Flex>
                ))}
            </Flex>
            <VSpacing default={16} />
        </>
    );
};
